import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: 'https://login.fairweben.de',
  realm: 'fairweben',
  clientId: 'fair-finance-app',
});

export default keycloak;
